import React from 'react';
import InputSwitch from "../../../../components/input/input-switch.jsx";

const IntegrationSharedImageCellRenderer = ({data, api, onChangeStatus}) => {
    return (
        <div className={"h-full w-full justify-items-center report-center text-center"}>
            <InputSwitch
                checked={data.status}
                onChange={(e) => onChangeStatus(e, data, api)}
            />
        </div>
    );
};

export default IntegrationSharedImageCellRenderer;